import { createLogger } from "../../utils/logger";
const logger = createLogger("HubCard");
// Abstract HubCard component
const HubCard = ({ hub, isSelected, onSelect, distanceInfo, t, lang }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect();
  };

  // Debug logging
  logger.log("HubCard distanceInfo:", distanceInfo);
  logger.log("HubCard hub:", hub);
  logger.log("HubCard hub.distanceInfo:", hub.distanceInfo);
  logger.log("HubCard distanceInfo type:", typeof distanceInfo);
  logger.log(
    "HubCard distanceInfo keys:",
    distanceInfo ? Object.keys(distanceInfo) : "undefined"
  );

  return (
    <div
      style={{
        border: isSelected ? "2px solid #ff114d" : "1px solid #e0e0e0",
        borderRadius: 8,
        padding: 20,
        marginBottom: 15,
        display: "flex",
        flexDirection: "column",
        position: "relative",
        cursor: "pointer",
        transition: "all 0.3s ease",
        backgroundColor: isSelected ? "#fff5f5" : "#f8f9fa",
        boxShadow: isSelected
          ? "0 4px 12px rgba(255, 17, 77, 0.15)"
          : "0 2px 8px rgba(0, 0, 0, 0.1)",
        userSelect: "none"
      }}
      onClick={handleClick}
      onMouseOver={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = "#ff114d";
          e.currentTarget.style.backgroundColor = "#fff5f5";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(255, 17, 77, 0.15)";
        }
      }}
      onMouseOut={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = "#e0e0e0";
          e.currentTarget.style.backgroundColor = "#f8f9fa";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
        }
      }}
    >
      {/* Radio Button */}
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          width: 20,
          height: 20,
          border: isSelected ? "2px solid #ff114d" : "2px solid #ccc",
          borderRadius: "50%",
          backgroundColor: isSelected ? "#ff114d" : "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none"
        }}
      >
        {isSelected && (
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "white"
            }}
          />
        )}
      </div>

      {/* Distance Badge */}
      {distanceInfo && distanceInfo.formattedDistance ? (
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            backgroundColor: distanceInfo.withinRange ? "#00b894" : "#fdcb6e",
            color: "white",
            padding: "6px 12px",
            borderRadius: 20,
            fontSize: 12,
            fontWeight: "bold",
            pointerEvents: "none"
          }}
        >
          {distanceInfo.formattedDistance}
          {distanceInfo.formattedDuration &&
            distanceInfo.formattedDuration !== "N/A" &&
            ` • ${distanceInfo.formattedDuration}`}
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            backgroundColor: "#636e72",
            color: "white",
            padding: "6px 12px",
            borderRadius: 20,
            fontSize: 12,
            fontWeight: "bold",
            pointerEvents: "none"
          }}
        >
          No Distance
        </div>
      )}

      {/* Content Container */}
      <div
        style={{
          marginLeft: 30,
          display: "flex",
          flexDirection: "column",
          gap: 4,
          pointerEvents: "none"
        }}
      >
        {/* Hub Name */}
        <h3
          style={{
            margin: 0,
            color: "#2d3436",
            fontSize: 16,
            fontWeight: "600",
            textTransform: "lowercase"
          }}
        >
          {hub?.name}
        </h3>

        {/* Address */}
        <div
          style={{
            fontSize: 14,
            color: "#636e72",
            lineHeight: 1.3
          }}
        >
          <div>{hub?.address}</div>

          {hub?.line && <div>{hub?.line}</div>}

          <div>
            {hub?.city}, {hub?.postalCode}
          </div>
        </div>

        {/* Delivery Time */}
        <div
          style={{
            fontSize: 14,
            color: "#636e72",
            lineHeight: 1.3,
            padding: "4px 8px",
            borderRadius: 4,
            display: "inline-block"
          }}
        >
          {t("order_details.from", lang)}: <b>{hub?.opening}</b>{" "}
          {t("order_details.to", lang)}: <b>{hub?.closing}</b>
        </div>

        {/* Instructions */}
        {hub?.instruction && (
          <div
            style={{
              fontSize: 14,
              color: "#636e72",
              lineHeight: 1.3
            }}
          >
            {t("order_details.instruction", lang)}: {hub?.instruction}
          </div>
        )}
      </div>
    </div>
  );
};

export default HubCard;
